import React, { useState, useEffect } from "react";
import MainDashboardLayout from "../../../../Layout/MainDashboardLayout";
import GRISidebar from "../../../../Layout/GRISidebar";
import styles from "../../../../styles/gri/general.module.css";
import {
  Box,
  Button,
  FormHelperText,
  Alert,
  Snackbar,
  MenuItem,
  Select,
  FormControl,
} from "@mui/material";
import EastIcon from "@mui/icons-material/East";
import { put, api, get } from "../../../../utils/api";
import { useNavigate, useParams } from "react-router-dom";
import DynamicTable from "../../../../Components/Common/DynamicTable";
import { validateLeadershipTable, validateTable } from "../../../../utils/validateTable";
import { restructureData } from "../../../../utils/restructureData";
import DynamicTableTotal from "./DynamicTableTotal";

import ReviewBox from "../../../../Components/Common/ReviewBox";
import { currentYear } from "../../../../utils/generateYearRanges";
import SectionHeading from "../../GRI300/GRI308/SectionHeading";

const GRI203_1 = ({ hide, downloadMode = false }) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [disabled, setDisabled] = useState(false);
  const [errors, setErrors] = useState({});
  const [snackOpen, setSnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const [griReview, setGriReview] = useState(() => JSON.parse(localStorage.getItem("griReview")));

  const inputData = [
    {
      fieldName: "infrastructureImpactOnCommunities",
      title:
        "b. How do you anticipate or currently observe impacts on communities and local economies due to your infrastructure investments and services? Please include both positive and negative impacts where applicable",
      fields: [
        {
          fieldName: "name",
          title: "Name of Investment / Service",
          type: "text",
          placeholder: "Enter Text",
          width: "20%",
        },
        {
          fieldName: "methodology",
          title: "Methodology",
          type: "text",
          placeholder: "Enter Text",
          width: "19%",
        },
        {
          fieldName: "positiveImpact",
          title: "Positive Impact",
          type: "text",
          placeholder: "Enter Text",
          width: "19%",
        },
        {
          fieldName: "negativeImpact",
          title: "Negative Impact",
          type: "text",
          placeholder: "Enter Text",
          width: "20%",
        },
      ],
    },
  ];

  const inputData1 = [
    {
      fieldName: "investmentAndServiceType",
      title:
        "c. Are the investments and services provided considered as commercial, in-kind, or pro bono engagements? Please specify for each.",
      fields: [
        {
          fieldName: "name",
          title: "Name of Investment / Service",
          type: "text",
          placeholder: "Enter Text",
          width: "35%",
        },
        {
          fieldName: "type1",
          title: "Type of engagement",
          type: "text",
          placeholder: "Enter Text",
          width: "35%",
        },
      ],
    },
  ];

  const inputData2 = [
    {
      fieldName: "finalcalAssistance",
      fields: [
        {
          fieldName: "name",
          title: "Name of Investment / Service",
          type: "text",
          placeholder: "Enter Text",
          width: "20%",
        },
        {
          fieldName: "cost",
          title: "Cost",
          type: "number",
          placeholder: "Enter Number",
          width: "19%",
        },
        {
          fieldName: "size",
          title: "Size",
          type: "number",
          placeholder: "Enter Number",
          width: "19%",
        },

        {
          fieldName: "duration",
          title: "Duration",
          type: "number",
          placeholder: "Enter Number",
          width: "20%",
        },
      ],
    },
  ];

  const [tables, setTables] = React.useState([]);

  const [tables1, setTables1] = React.useState([]);

  const [tables2, setTables2] = React.useState([]);

  const [tabErrors, setTabErrors] = useState({});
  const [tabErrors1, setTabErrors1] = useState({});
  const [tabErrors2, setTabErrors2] = useState({});

  const [currency, setCurrency] = useState("");
  const [data, setData] = useState({});

  const currencies = [
    { code: "USD", name: "USD" },
    { code: "EUR", name: "EUR" },
    { code: "INR", name: "INR" },
    // { code: "GBP", name: "British Pound" },
    // { code: "JPY", name: "Japanese Yen" },
  ];

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await get(`/gri/get?type=GRI200&Id=${id}`);
        if (response?.data?.data?.year < currentYear - 1) setDisabled(true);
        const data1 = response.data.data.GRI200 || {};
        setData(data1);
        setCurrency(data1?.finalcalAssistanceCurrency || "");
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, []);

  const handleCurrencyChange = (event) => {
    setCurrency(event.target.value);
  };

  const validateForm = () => {
    let newErrors = {};
    let formIsValid = true;

    // if (!currency.finalcalAssistanceCurrency) {
    //     newErrors.finalcalAssistanceCurrency = "This field is required";
    //     formIsValid = false;
    //   }

    // Validate required fields in the formData

    setErrors(newErrors);
    return formIsValid;
  };

  const handleSubmit = async () => {
    if (!disabled) {
      // if (!validateForm()) return;  // Validate form before submission
      const isFormValid = validateForm();
      const isTableValid = validateLeadershipTable(inputData, tables, setTabErrors);
      const isTable1Valid = validateLeadershipTable(inputData1, tables1, setTabErrors1);
      const isTable2Valid = validateLeadershipTable(inputData2, tables2, setTabErrors2);

      if (!isFormValid || !isTableValid || !isTable1Valid || !isTable2Valid) {
        return;
      }

      let transformedData = restructureData(tables);
      let transformedData1 = restructureData(tables1);
      let transformedData2 = restructureData(tables2);

      const payload = {
        type: "GRI200",
        submitted203_1: true,
        finalcalAssistanceCurrency: currency,
        ...transformedData,
        ...transformedData1,
        ...transformedData2,
      };

      try {
        const token = sessionStorage.getItem("token");
        if (!token) {
          throw new Error("Authentication token is missing.");
        }
        await put(`/gri/update?Id=${id}`, payload);
        navigate(`/gri/economic-performance/203-2/${id}`);
      } catch (error) {
        console.error("Error updating data:", error);
        setSnackOpen({
          open: true,
          message: "Error updating data. Please try again.",
          severity: "error",
        });
      }
    } else {
      navigate(`/gri/economic-performance/203-2/${id}`);
    }
  };

  const renderContent = ({ hide }) => (
    <>
      {!hide && (
        <p
          className={styles.section_heading}
          style={{ marginBottom: hide ? "-1rem" : "0" }}
        >
          203 : Indirect Economic Impact
        </p>
      )}
      <p className={styles.main_heading}>
        203-1 : Infrastructure investments and services supported
      </p>

      {/* Section A */}
      <SectionHeading
        text="a. Financial assistance received by country"
        sx={{ marginTop: hide ? "-1rem" : "0" }}
      />
      <Box sx={{ marginLeft: "1.1rem" }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            marginBottom: "-2.6rem",
            width: "50%",
          }}
        >
          <Box sx={{ marginRight: 2, fontWeight: 600,fontFamily:"inter" }}>Currency:</Box>
          <FormControl sx={{ minWidth: "40%" }} size="small" variant="outlined">
            <Select
              value={currency ||""}
              onChange={handleCurrencyChange}
              displayEmpty
              disabled={disabled}
            >
              <MenuItem value="">
                Select
              </MenuItem>
              {currencies.map((currencyOption) => (
                <MenuItem key={currencyOption.code} value={currencyOption.code}>
                  {currencyOption.name}
                </MenuItem>
              ))}
            </Select>
            {errors.finalcalAssistanceCurrency && (
              <FormHelperText
                variant="body2"
                color="error"
                style={{
                  lineHeight: "1.2",
                  margin: "2px 0",
                  color: "#d34040",
                  fontSize: "10px",
                  fontStyle: "italic",
                }}
              >
                {errors.finalcalAssistanceCurrency}
              </FormHelperText>
            )}
          </FormControl>
        </Box>
        <DynamicTableTotal
          inputData={inputData2}
          tables={tables2}
          data={data}
          setTables={setTables2}
          errors={tabErrors2}
          disabled={disabled}
          setErrors={setTabErrors2}
          hide={hide}
        />
      </Box>

      {/* Section B */}
      <DynamicTable
        inputData={inputData}
        tables={tables}
        data={data}
        disabled={disabled}
        setTables={setTables}
        errors={tabErrors}
        setErrors={setTabErrors}
        hide={hide}
      />

      {/* Section c */}
      {downloadMode && <Box sx={{ pageBreakBefore: "always" }}></Box>}
      <DynamicTable
        inputData={inputData1}
        tables={tables1}
        data={data}
        disabled={disabled}
        setTables={setTables1}
        errors={tabErrors1}
        setErrors={setTabErrors1}
        hide={hide}
      />

      <Box sx={{ display: "flex", flexDirection: "column" }}>
        {/* Submit Button */}

        {/* Snackbar for success/error messages */}
        <Snackbar
          open={snackOpen.open}
          message={snackOpen.message}
          autoHideDuration={3000}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          onClose={() => setSnackOpen({ ...snackOpen, open: false })}
        >
          <Alert
            severity={snackOpen.severity}
            variant="filled"
            sx={{ width: "100%" }}
          >
            {snackOpen.message}
          </Alert>
        </Snackbar>
      </Box>
    </>
  );

  return (
    <>
      {!hide ? (
        <MainDashboardLayout sidebar={<GRISidebar />}>
          {renderContent({ hide })}

          <>
            {!griReview ? (
              <Box sx={{ ml: "1rem", width: "98%" }}>
                <ReviewBox
                  url={"/gri"}
                  handleSubmit={handleSubmit}
                  url1={`/gri/economic-performance/203-2/${id}`}
                />
              </Box>
            ) : (
              <Box textAlign="right" sx={{ mt: 3 }}>
                <Button
                  variant="contained"
                  sx={{
                    bgcolor: "#1C486B",
                    textTransform: "none",
                    mt: 3,
                    mb: 5,
                  }}
                  onClick={handleSubmit}
                >
                  Save & Continue <EastIcon sx={{ ml: 2 }} />
                </Button>
              </Box>
            )}
          </>
        </MainDashboardLayout>
      ) : (
        renderContent({ hide })
      )}
    </>
  );
};

export default GRI203_1;
